import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { CSSTransition } from 'react-transition-group';
import { MobileNavbar } from '../NavBar/Mobile/MobileNavbar';
import eventimg from '../../assets/eventimg.png'
import spinner from '../../assets/spinner.gif'
import { HomeTypeCard } from '../Card/HomeTypeCard/HomeTypeCard';

export const PageEvent = () => {

    const [detail, setDetail] = useState()
    const [loading, setLoading] = useState(true)
    const [showNavPopup, setShowNavPopup] = useState(false)
    const handleCloseAll = () => {
        setShowNavPopup(false)
    }
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail([{gambar:eventimg,judul:"Thanksgiving",style:"American style featuring Turkey and Sides", sisa:10, total:20, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Cilandak Town Square, Jalan Tahi Bonar Simatupang, RT.6/RW.9, West Cilandak, South Jakarta City, Jakarta, Indonesia"},
        {gambar:eventimg,judul:"Asian Party",style:"Asian Style", sisa:3, total:10, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Hotel Santika, BSD City"},
        {gambar:eventimg,judul:"Welcome",style:"American style featuring Turkey and Sides", sisa:10, total:10, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Hotel Santika, BSD City"},
        {gambar:eventimg,judul:"Thanksgiving",style:"American style featuring Turkey and Sides", sisa:10, total:20, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Cilandak Town Square, Jalan Tahi Bonar Simatupang, RT.6/RW.9, West Cilandak, South Jakarta City, Jakarta, Indonesia"},
        {gambar:eventimg,judul:"Asian Party",style:"Asian Style", sisa:3, total:10, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Hotel Santika, BSD City"},
        {gambar:eventimg,judul:"Welcome",style:"American style featuring Turkey and Sides", sisa:10, total:10, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Hotel Santika, BSD City"}])
        localStorage.setItem('nav', 'e')
    },[])
    const [standby, setstandby] = useState(true)
    const firstUpdate = useRef(true);
    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            setLoading(false)
        }
    },[detail])

    
    
    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <MobileNavbar></MobileNavbar>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="EPtrans">
                <div>
                    <div className='EPatas'>
                        <p className='white big bold EPtittle'>Next Event</p>
                        <HomeTypeCard 
                            gambar = {detail[0].gambar} 
                            judul = {detail[0].judul} 
                            style = {detail[0].style} 
                            sisa = {detail[0].sisa} 
                            total = {detail[0].total} 
                            tanggal = {detail[0].tanggal} 
                            jam = {detail[0].jam} 
                            tempat = {detail[0].tempat}
                            showJoinNow = {true}
                            fungsi={()=>setstandby(false)}
                        />

                        <p className='white big bold EPtittle'>Upcoming Event</p>
                        <div className='EPupcomingevent flexwrap'>
                            {
                                detail.slice(1,detail.length).map((post) => (
                                    <HomeTypeCard 
                                        gambar = {post.gambar} 
                                        judul = {post.judul} 
                                        style = {post.style} 
                                        sisa = {post.sisa} 
                                        total = {post.total} 
                                        tanggal = {post.tanggal} 
                                        jam = {post.jam} 
                                        tempat = {post.tempat}
                                        fungsi={()=>setstandby(false)}
                                    />
                                ))
                            }
                        </div>
                    </div>
                </div>
                </CSSTransition>
            }
        </div>
    )
  }